import './base.css';

import App from './App';
import React from 'react';

import reportWebVitals from './reportWebVitals';
import moment from 'moment';
import { createRoot } from 'react-dom/client';
import ReactDOM from 'react-dom';

const el = document.getElementById('root') as HTMLElement;

if (process.env.ReactVersion?.toString() === '18') createRoot(el).render(<App />);
else ReactDOM.render(<App />, el);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/* eslint-disable no-extend-native */
Date.prototype.toJSON = function () {
  return moment(this).format('YYYY-MM-DDTHH:mm:ss');
};
/* eslint-enable no-extend-native */
